'use client';

import { useState } from 'react';
import { Container } from 'components/gruenland/atoms/container/Container';
import Button from 'components/gruenland/atoms/button/Button';
import { useFormat } from 'helpers/hooks/useFormat';
import PublicOrderForm from './components/PublicOrderForm';
import PublicOrderPage from './components/PublicOrderPage';
import usePublicOrder from './hooks/usePublicOrder';

type Props = {
  search: {
    email?: string;
    order?: string;
  };
};

const PublicOrder: React.FC<Props> = ({ search }) => {
  const { order, shippingMethods } = usePublicOrder(search);
  const { formatMessage } = useFormat({ name: 'gruenland' });
  const [showSearchForm, setShowSearchForm] = useState(false);

  // If order is loaded, show it with a button to search for another order
  if (order) {
    return (
      <Container>
        <PublicOrderPage order={order} shippingMethods={shippingMethods.data ?? []} />
        {!showSearchForm && (
          <div className="mt-8 px-4 md:px-6 lg:px-11">
            <Button onClick={() => setShowSearchForm(true)}>
              {formatMessage({ id: 'publicorder.searchAnother', defaultMessage: 'Cerca un altro ordine' })}
            </Button>
          </div>
        )}
        {showSearchForm && <PublicOrderForm />}
      </Container>
    );
  }

  return (
    <Container>
      {search.email && search.order && (
        <div className="px-4 md:px-6 lg:px-11">
          <div className="border-l-4 border-red-500 bg-red-100 p-1 text-red-700" role="alert">
            <p className="font-bold">
              {formatMessage({ id: 'publicorder.notFound', defaultMessage: 'Ordine non trovato.' })}
            </p>
          </div>
        </div>
      )}
      <PublicOrderForm email={search.email} order={search.order} />
    </Container>
  );
};

export default PublicOrder;
